import Design1 from './design-1';
import {useContext, useEffect, useState} from "react";
import axios from "axios";
import {filterItems} from "../../utils/utils";
import {WebsiteContext} from "../../index";
import useApplyUserDefinedListOverrides from "../../hooks/use-user-defined-list-sort";
import { buildParams } from "../products-list-block/filters";
import getPreviewBaseUrl from "../../utils/preview-domain";
ProductsBlock.propTypes = {};

ProductsBlock.defaultProps = {};

const designs = [Design1];

const productFilterToActiveFilters = (productFilter = {}) => {
    const out = {};
    const {filters = {}, sortBy, order} = productFilter || {};

    Object.entries(filters).forEach(([key, val]) => {
        if (val === null || val === undefined || val === '') return;

        if (Array.isArray(val)) {
            out[key] = val;
        } else if (typeof val === 'object') {
            if (val.min !== null && val.min !== undefined && val.min !== '') out[`${key}-min`] = val.min;
            if (val.max !== null && val.max !== undefined && val.max !== '') out[`${key}-max`] = val.max;
            if (val.from !== null && val.from !== undefined && val.from !== '') out[`${key}-from`] = val.from;
            if (val.to !== null && val.to !== undefined && val.to !== '') out[`${key}-to`] = val.to;
            if (val.value !== null && val.value !== undefined && val.value !== '') out[key] = val.value;
        } else {
            out[key] = val;
        }
    });

    if (sortBy) {
        if (Array.isArray(sortBy)) out.sort = sortBy;
        else out.sort = [String(sortBy)];
    }

    if (Array.isArray(order) && order.length) {
        const ids = order.map(o => (typeof o === 'object' && o) ? (o.id ?? o.value ?? o) : o);
        out.order = ids.join(',');
    }

    return out;
};

export default function ProductsBlock(props) {
    const context = useContext(WebsiteContext);
    const DesignBlock = designs[props.values?.design] ?? Design1;
    const [items, setItems] = useState(() => filterItems(props?.values?.items || []));
    const [cardActionForms, setCardActionForms] = useState(() => props?.values?.cardActionForms || {});
    const [state, setState] = useState(() => {
        if (items.length === 0) return props?.values?.emptyState;
    });

    useEffect(() => {
        const cancelToken = axios.CancelToken.source();
        const emptyState = props?.values?.emptyState || 'placeholder';
        let active = true;

        if (context.builder) {
            const previewBaseUrl = getPreviewBaseUrl(context?.website?.previewDomain);
            setItems([]);
            setCardActionForms({});
            setState(emptyState);

            if (!previewBaseUrl) return () => {
                active = false;
                cancelToken.cancel();
            };

            axios
                .post(`/api/v2/website/products`, {...props?.values}, {
                    headers: {"X-Preview-Domain": previewBaseUrl},
                    cancelToken: cancelToken.token,
                })
                .then(({data}) => {
                    if (!active) return;
                    if (data?.items?.length > 0) {
                        setItems(filterItems(data.items))
                        setCardActionForms(data?.cardActionForms || {})
                        setState(null)
                    } else {
                        setItems([])
                        setCardActionForms({})
                        setState(emptyState)
                    }
                })
                .catch((err) => {
                    if (active && !axios.isCancel(err)) {
                        console.error("Failed to fetch products data:", err)
                        setItems([])
                        setCardActionForms({})
                        setState(emptyState)
                    }
                })
        } else {
            const nextItems = filterItems(props?.values?.items || []);
            setItems(nextItems);
            setCardActionForms(props?.values?.cardActionForms || {});
            setState(nextItems.length > 0 ? null : props?.values?.emptyState);
        }
        return () => {
            active = false;
            cancelToken.cancel();
        };
    }, [props?.values, context.builder, context?.website?.previewDomain]);

    const values = useApplyUserDefinedListOverrides({
        ...props,
        items,
        itemsPositions: props?.values?.itemsPositions
    });

    // --- Build action.value when using filteredProducts ---
    let finalValues = values;
    const actionType = values?.action?.type;
    if (actionType === 'filteredProducts') {
        const filterType = values?.filterType;
        const directUrl = values?.filterUrl || values?.filterUri;

        if (filterType === 'url') {
            finalValues = {
                ...values,
                action: {
                    ...values.action,
                    value: directUrl
                }
            };
        } else if (filterType === 'category' && values?.categoryUuid) {
            // Try to resolve a base path for the category from actionLookup
            const base = context?.actionLookup?.[values.categoryUuid];
            if (base) {
                const activeFilters = productFilterToActiveFilters(values?.productFilter);
                const qs = buildParams(activeFilters, false, base);
                const href = `${base}${qs}`;
                finalValues = {
                    ...values,
                    action: {
                        ...values.action,
                        value: href
                    }
                };
            }
        }
    }
    // -----------------------------------------------------

    return (
        <DesignBlock {...props} values={{...finalValues, cardActionForms}} state={state}/>
    )
};
